import React from 'react';
import PropTypes from 'prop-types';
import { Global } from '@emotion/core';
import { t as theme } from '../theme-f3bad038.js';
export { w as withTheme } from '../theme-f3bad038.js';
import { ThemeProvider } from 'emotion-theming';
var general = theme => ({
  html: {
    fontSize: theme.font.baseline
  },
  body: {
    margin: 0,
    padding: 0,
    color: theme.colors.black,
    fontFamily: theme.font.family.body,
    fontSize: theme.font.scale.default,
    fontSmoothing: 'antialiased'
  },
  img: {
    maxWidth: '100%',
    height: 'auto'
  },
  a: {
    color: 'inherit',
    textDecoration: 'none',
    '&:focus': {
      ...theme.styles.focused
    }
  },
  ul: {
    margin: 0,
    padding: 0,
    listStyleType: 'none'
  },
  fieldset: {
    border: 'none',
    margin: 0,
    padding: 0
  },
  button: {
    border: 'none',
    padding: 0,
    background: 'inherit',
    fontFamily: theme.font.family.body,
    '&:focus': {
      ...theme.styles.focused
    }
  },
  input: {
    lineHeight: 'normal'
  },
  '@page': {
    size: 'auto',
    margin: '5%'
  }
});
const StylesProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(Global, {
    styles: general
  }), children);
};
StylesProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default StylesProvider;